import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es7.string.pad-start";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { sm4 } from 'sm-crypto';
var SM4_KEY = '1w2sdfr890s12s34';
var BJCA_LOCAL_TEST_KEY = 'BJCA_LOCAL_TEST';
function stringToHex(str) {
  var hex = '';
  for (var i = 0; i < str.length; i++) {
    hex += str.charCodeAt(i).toString(16).padStart(2, '0');
  }
  return hex;
}
export default {
  name: "MobileLogin",
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      step: 0,
      loading: false,
      isLocalBjcaTestEnabled: process.env.NODE_ENV === 'development',
      localTestLoading: false,
      bntsList: [{
        id: '1',
        name: '北京市教育统一认证'
      }, {
        id: '2',
        name: '账号密码登录'
      }, {
        id: '3',
        name: '智教中国通行证'
      }],
      userMsg: {
        username: "",
        password: ""
      },
      localTestForm: {
        jyId: ''
      },
      userRules: {
        username: [{
          required: true,
          message: "请输入账号",
          trigger: "blur"
        }, {
          min: 2,
          max: 18,
          message: "长度在 2 到 18 个字符",
          trigger: "blur"
        }, {
          required: true,
          pattern: /^[\u4e00-\u9fa5_a-zA-Z0-9.·-]+$/,
          message: "账号不支持特殊字符",
          trigger: "blur"
        }],
        password: [{
          required: true,
          message: "请输入密码",
          trigger: "blur"
        }]
      },
      localTestRules: {
        jyId: [{
          required: true,
          message: "请输入教育ID",
          trigger: "blur"
        }]
      }
    };
  },
  computed: {
    cssVars: function cssVars() {
      return {
        "--ml-overlay-bg": "rgba(0,0,0,0.45)",
        "--ml-modal-w": "88%",
        "--ml-modal-max-w": "400px",
        "--ml-modal-radius": "16px",
        "--ml-modal-bg": "#fff",
        "--ml-close-size": "24px",
        "--ml-close-top": "12px",
        "--ml-close-right": "12px",
        "--ml-body-padding": "28px 24px",
        "--ml-title-size": "22px",
        "--ml-title-mb": "28px",
        "--ml-item-h": "60px",
        "--ml-item-radius": "12px",
        "--ml-item-bg": "#f2f6fe",
        "--ml-item-margin": "0 0 16px",
        "--ml-item-padding": "0 20px",
        "--ml-icon-size": "36px",
        "--ml-name-size": "18px",
        "--ml-arrow-size": "24px",
        "--ml-input-h": "52px",
        "--ml-input-size": "18px",
        "--ml-input-radius": "10px",
        "--ml-btn-h": "52px",
        "--ml-btn-size": "19px",
        "--ml-btn-radius": "12px",
        "--ml-btn-bg": "#2645c1",
        "--ml-back-size": "16px",
        "--ml-back-mb": "20px",
        "--ml-foot-size": "14px",
        "--ml-foot-line": "24px"
      };
    }
  },
  watch: {
    visible: function visible(val) {
      if (val) this.step = 0;
    }
  },
  methods: {
    close: function close() {
      this.$emit("update:visible", false);
    },
    tologin: function tologin(_ref) {
      var id = _ref.id;
      var targetUrl = 'https://am.bjedu.cn/am/oauth2/authorize?service=initService&response_type=code&client_id=8ad2f7b1fe0a444e&scope=uid+cn+userIdCode&redirect_uri=https://vocational.beijing.smartedu.cn/system/auth/bjca/login&decision=Allow';
      if (!id || id == 2) {
        this.step = 1;
        return;
      }
      if (id == 4) {
        this.step = 2;
        return;
      }
      if (id == 3) {
        targetUrl = 'https://am.bjedu.cn/am/zjNationEdu/authorize.do?clientId=8ad2f7b1fe0a444e';
      }
      window.open(targetUrl, '_self');
    },
    doLogin: function doLogin() {
      var _this = this;
      this.$refs.mLoginForm.validate(function (valid) {
        if (!valid) return;
        _this.loading = true;
        var users = {
          username: _this.userMsg.username,
          password: sm4.encrypt(_this.userMsg.password, stringToHex(SM4_KEY))
        };
        _this.$store.dispatch("user/login", users).then(function () {
          _this.$store.dispatch("user/getInfo").then(function () {
            _this.loading = false;
            _this.close();
            sessionStorage.setItem("isFlag", "true");
            _this.$message.success("操作成功。");
          });
        }).catch(function () {
          _this.loading = false;
          _this.$message.error("登录失败");
        });
      });
    },
    localTestLogin: function localTestLogin() {
      var _this2 = this;
      this.$refs.mLocalForm.validate(function (valid) {
        if (!valid) return;
        _this2.localTestLoading = true;
        _this2.$store.dispatch("user/localBjcaLogin", _this2.localTestForm.jyId.trim()).then(function () {
          _this2.localTestLoading = false;
          _this2.close();
          sessionStorage.setItem(BJCA_LOCAL_TEST_KEY, "true");
          sessionStorage.setItem("isFlag", "true");
          _this2.$message.success("本地测试登录成功");
        }).catch(function (error) {
          _this2.localTestLoading = false;
          _this2.$message.error(error && error.message || "本地测试登录失败");
        });
      });
    }
  }
};